export default __webpack_public_path__ + "9a8128882a93a187759ea87d01957fc8.svg";